import React from 'react';
import ModalBlock from '../../../components/ModalBlock';
import { formatDateTime, getExtractionMethodLabel, getSourceKindLabel, getStatusMetadata, joinDisplayValues } from './systemDocumentMetadata';

const SystemDocumentDetailsModal = ({ show, onHide, document }) => {
  const detailFields = [
    { label: 'Document', value: document?.title || document?.fileName },
    { label: 'Source Type', value: document ? getSourceKindLabel(document.sourceKind) : null },
    { label: 'Project', value: joinDisplayValues(document?.projectNumber, document?.projectName) },
    { label: 'Proposal', value: document?.proposalId ? `Proposal ${document.proposalId}` : null },
    { label: 'Job', value: document?.jobId ? `Job ${document.jobId}` : null },
    { label: 'Client', value: document?.clientName },
    { label: 'Location', value: document?.locationName },
    { label: 'Source Updated', value: formatDateTime(document?.sourceUpdatedAt) },
    { label: 'AI Status', value: document ? getStatusMetadata(document.status).label : null },
    { label: 'Extraction Method', value: getExtractionMethodLabel(document?.extractionMethod) },
    { label: 'Extraction Version', value: document?.extractionVersion },
    { label: 'Indexed At', value: formatDateTime(document?.indexedAt) },
    { label: 'Chunk Count', value: document ? document.chunkCount : null },
    { label: 'Embedding Model', value: document?.embeddingModel },
    { label: 'Metadata Version', value: document?.metadataVersion },
  ];

  return (
    <ModalBlock
      centered
      size='lg'
      show={show}
      onHide={onHide}
      closeAction
      closeActionOnClick={onHide}
      contentHeader='System Document Details'
      subtitle={document?.projectNumber || ''}
    >
      <div className='row mt-5'>
        {detailFields.map((field) => (
          <div key={field.label} className='col-12 col-md-6 mb-5'>
            <div className='text-muted font-size-sm font-weight-bold mb-1'>{field.label}</div>
            <div className='text-dark text-break'>{field.value ?? <span className='text-muted'>&mdash;</span>}</div>
          </div>
        ))}
      </div>
    </ModalBlock>
  );
};

export default SystemDocumentDetailsModal;
